// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthHeaderColumn_root__3qufh","flex":"MonthHeaderColumn_flex__lmGEX","label":"MonthHeaderColumn_label__2KyuW","day":"MonthHeaderColumn_day__24V_k"};